import filtros from "./filtros";

export default {
  namespaced: true,
  modules: {
    filtros
  }
};
